import chroma from "chroma-js";

// Check if a color is dark (returns true if dark, false if light)
const isDarkColor = (color: string): boolean => {
  try {
    // Handle transparent or invalid colors
    if (!color || ["transparent", "none", ""].includes(color)) {
      return false;
    }

    const luminance = chroma(color).luminance();
    return luminance < 0.5; // threshold for dark/light
  } catch (error) {
    console.error("Error checking if color is dark:", error);
    return false;
  }
};

export default isDarkColor;
